/**
 * Infinite Scroll for Product Collections
 * Automatically loads more products as user scrolls down
 */

(function() {
  'use strict';

  var InfiniteScroll = {
    init: function() {
      this.container = document.querySelector('.grid--view-items');
      this.loadMoreButton = document.querySelector('[data-infinite-scroll-trigger]');
      this.loading = false;
      this.currentPage = 1;
      
      if (!this.container) {
        return;
      }

      this.bindEvents();
    },

    bindEvents: function() {
      var self = this;
      
      // Throttle scroll event for better performance
      var scrollTimeout;
      window.addEventListener('scroll', function() {
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        
        scrollTimeout = setTimeout(function() {
          self.onScroll();
        }, 150);
      });

      // Also support manual "Load More" button if present
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', function(e) {
          e.preventDefault();
          self.loadMore();
        });
      }
    },

    onScroll: function() {
      if (this.loading) {
        return;
      }

      var scrollPosition = window.scrollY + window.innerHeight;
      var documentHeight = document.documentElement.scrollHeight;
      
      // Trigger load when user is 500px from bottom
      if (scrollPosition >= documentHeight - 500) {
        this.loadMore();
      }
    },

    loadMore: function() {
      var nextPageLink = document.querySelector('[data-next-page]');
      
      if (!nextPageLink || this.loading) {
        return;
      }

      this.loading = true;
      this.showLoader();

      var nextPageUrl = nextPageLink.getAttribute('href');
      
      var self = this;
      fetch(nextPageUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          self.parseAndAppendProducts(html);
          self.loading = false;
          self.hideLoader();
        })
        .catch(function(error) {
          console.error('Error loading more products:', error);
          self.loading = false;
          self.hideLoader();
        });
    },

    parseAndAppendProducts: function(html) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Extract products from the response
      var newProducts = tempDiv.querySelectorAll('.grid--view-items > .grid__item');
      
      if (newProducts.length > 0) {
        var fragment = document.createDocumentFragment();
        
        newProducts.forEach(function(product) {
          fragment.appendChild(product);
        });
        
        this.container.appendChild(fragment);
        
        // Trigger lazy loading for new images if lazysizes is available
        if (window.lazySizes) {
          window.lazySizes.autoSizer.checkElems();
        }
      }

      // Update next page link
      var oldNextLink = document.querySelector('[data-next-page]');
      var newNextLink = tempDiv.querySelector('[data-next-page]');
      
      if (oldNextLink) {
        if (newNextLink) {
          oldNextLink.setAttribute('href', newNextLink.getAttribute('href'));
          this.currentPage++;
        } else {
          // No more pages
          oldNextLink.remove();
          this.showEndMessage();
        }
      }
    },

    showLoader: function() {
      var loader = document.querySelector('.infinite-scroll-loader');
      if (loader) {
        loader.style.display = 'block';
      }
    },

    hideLoader: function() {
      var loader = document.querySelector('.infinite-scroll-loader');
      if (loader) {
        loader.style.display = 'none';
      }
    },

    showEndMessage: function() {
      var endMessage = document.querySelector('.infinite-scroll-end');
      if (endMessage) {
        endMessage.style.display = 'block';
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      InfiniteScroll.init();
    });
  } else {
    InfiniteScroll.init();
  }

})();

